import type { Milliseconds } from '@lemonade-hq/ts-helpers';
import { useEffect, useState } from 'react';

export const useDelayedValue = <T>(value: T, initialValue: T, delay: Milliseconds = 0): T => {
  const [delayedValue, setDelayedValue] = useState(initialValue);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDelayedValue(value);
    }, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, [value, delay]);

  return delayedValue;
};
